<template>

    <div v-if="$auth.ready()" class="admin-home-container">
        <navbar v-if="userLogged"/>
        <div class="title" v-if="userLogged">
            {{ $t($route.name) }}
        </div>
        <transition name="fade" mode="out-in">
            <router-view :key="$route.fullPath"/>
        </transition>
    </div>
    <div v-else>
        Loading ...
    </div>

</template>

<script>
import Navbar from './Navbar'

export default {
    components: {Navbar},
    computed: {
        userLogged: function () {
            return this.$auth && this.$auth.user();
        }
    }
}

</script>

<style lang="scss">

</style>
